import Button from 'devextreme-react/button';
import React, { useState } from 'react';
import { Navigate } from 'react-router';

import { useSignedIn } from '@/core/auth/auth';
import { isEntraConfigured, loginWithEntra } from '@/core/auth/msal';

export const LoginPage: React.FC = () => {
  const signedIn = useSignedIn();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (signedIn) {
    return <Navigate to="/" replace />;
  }

  // A customer deployment: Entra, one button, no password here.
  if (isEntraConfigured()) {
    return (
      <main className="login-page">
        <div className="login-card">
          <h1>Lanes</h1>
          <p>Sign in with your company Microsoft account.</p>
          {error && <p role="alert">{error}</p>}
          <Button
            text={busy ? 'Redirecting…' : 'Sign in with Microsoft'}
            type="default"
            stylingMode="contained"
            width="100%"
            disabled={busy}
            onClick={() => {
              setError(null);
              setBusy(true);
              void loginWithEntra().catch((err: unknown) => {
                setError(err instanceof Error ? err.message : 'Sign-in failed');
                setBusy(false);
              });
            }}
          />
        </div>
      </main>
    );
  }

  return (
    <main className="login-page">
      <div className="login-card">
        <h1>Lanes</h1>
        <p role="alert">
          Sign-in is not configured: the build needs VITE_ENTRA_TENANT_ID,
          VITE_ENTRA_CLIENT_ID and VITE_ENTRA_API_SCOPE.
        </p>
      </div>
    </main>
  );
};
